import { classes, media, style } from "typestyle";
import colors from "../../styles/colors";
import fontSize from "../../styles/fontSize";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";
import { mb2, mb3, mb4, mb8, pr12 } from "../../styles/spacing";

export const mapImage = style({
  width: "100%",
  borderRadius: 12,
  overflow: "hidden",
});

export const infoBox = style(
  media(upFrom(mediaQueries.desktopSmall), {
    display: "flex",
  }),
  mb8,
);

export const infoBoxTitle = style(
  media(mediaQueries.desktopSmall, { width: 250 }, pr12),
  media(mediaQueries.desktopLarge, { width: 350 }, pr12),
  mb3,
);

export const infoBoxContent = style({
  flex: 1,
});

export const infoText = classes(style({ fontWeight: 500 }), fontSize.sm);

export const addressText = classes(style({ fontWeight: 500 }), fontSize.sm);

export const informationText = style(mb3);

export const buttonGroup = style();

// map stuff
export const mapWrapper = style(
  {
    position: "relative",
    padding: "4px",
  },
  mb2,
);

export const mapPin = style({
  position: "absolute",
  left: "calc(50% - 15px)",
  top: "calc(50% - 22px)",
});

export const directions = classes(fontSize.sm, style(mb4));

export const locationContainer = style({
  marginTop: "1rem",
  border: "1px solid rgba(213, 218, 230, 1)",
  borderRadius: "16px",
});

export const addressContainer = style({
  display: "flex",
  padding: "0.75rem",
  paddingTop: "0",
  justifyContent: "space-between",
  alignItems: "center",
});

export const address = style({
  display: "flex",
  flexDirection: "column",
  color: "black",
  $nest: {
    "&>span:not(:last-child)": {
      marginBottom: "1px",
    },
  },
});

export const mapButton = classes(
  style({
    background: colors.grey[100],
    fontWeight: 500,
    padding: "0.25rem 0.75rem !important",
    minHeight: "36px !important",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    $nest: {
      "&>span>svg": {
        color: "#8C94A3",
      },
    },
  }),
  fontSize.xs,
);

export const addressHeader = style({
  fontWeight: 400,
});

export const organizerInfoBox = style({
  display: "flex",
  alignItems: "center",
  flex: 1,
  border: "1px solid rgba(213, 218, 230, 1)",
  padding: "1rem 0.75rem",

  borderRadius: 12,
  marginTop: "16px",
  $nest: {
    "&>div:first-child": {
      marginRight: "8px",
    },
  },
});

export const organizerInfoBoxText = classes(
  style({
    display: "flex",
    flexDirection: "column",
    fontWeight: 500,
    $nest: {
      "&>*:first-child": {
        color: colors.grey[600],
        opacity: 0.85,
        fontWeight: 400,
      },
    },
  }),
  fontSize.sm,
);

export const organizerInfo = style(
  {
    display: "flex",
    flexDirection: "column",
  },
  media(upFrom(mediaQueries.tablet), {
    flexDirection: "row",
    $nest: { "&>*:last-child": { marginLeft: "8px" } },
  }),
);
